export default "__VITE_ASSET__n30LGqwE__"